import moment from 'moment';

export const TIME_FORMAT = 'HH:mm';

export default function time(dateInJSON) {
  return moment(dateInJSON).format(TIME_FORMAT);
}
